module.exports = __webpack_public_path__ + "assets/img/logo.2851c1e0ef07b7cb43700a8c813bcabe.svg";